import axios from 'axios';

const api = axios.create({
  baseURL: 'https://www.redevidaanimal.com/api/v1/',
});

export default api